<template>
    <div>
        <navTitle
                :title="$router.app._route.query.ti ? $router.app._route.query.ti : 'Recharge information'"></navTitle>
        <div class="row-wrap">
            <div class="row-T1">Please fill in the payment information</div>
            <div class="row">
                <div class="row-name">Amount(₱)</div>
                <input class="input" readonly v-model="money"/>
            </div>
            <div class="row">
                <div class="row-name">Phone</div>
                <input class="input" type="number" placeholder="63****" v-model="phone"/>
            </div>
            <div class="row">
                <div class="row-name">Name</div>
                <input class="input" placeholder="Enter your name" v-model="name"/>
            </div>
            <div class="row">
                <div class="row-name">Email</div>
                <input class="input" placeholder="Enter your email" v-model="email"/>
            </div>
            <div class="row">
                <div class="row-name">Recharge Method</div>
                <select class="select" v-model="paytypecode">
                    <option value="21001">GCash</option>
                    <option value="21002">PayMaya</option>
                </select>
            </div>
        </div>
        <div class="pay-btn bg-color-blue" @click="recharge">Confirm</div>
    </div>
</template>

<script>
    import navTitle from "@components/navTitle"
    import {payment_create} from "../../api/user";

    export default {
        name: "rechargeMethod",
        components: {navTitle},
        data() {
            return {
                money: this.$route.query.m,
                phone: '',
                name: '',
                email: '',
                paytypecode: '21001 '
            }
        },
        activated() {
        },
        methods: {
            recharge() {
                if (this.phone === '') {
                    return this.$dialog.toast({mes: 'Please fill in your mobile phone number'});
                }
                const phoneReg = /^(639)\d{9}$/;
                if (!phoneReg.test(this.phone)) {
                    return this.$dialog.toast({mes: 'Malformed phone number'});
                }
                if (this.name === '') {
                    return this.$dialog.toast({mes: 'Please fill in your name'});
                }
                if (this.email === '') {
                    return this.$dialog.toast({mes: 'Please fill in your email'});
                }
                const regex = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
                if (!regex.test(this.email)) {
                    return this.$dialog.toast({mes: 'E-mail format error'});
                }

                const param = {
                    amount: this.money,
                    phone: this.phone,
                    name: this.name,
                    email: this.email,
                    paytypecode: this.paytypecode
                }
                // console.log(param)
                // return
                payment_create(param).then(res => {
                    this.$dialog.loading.close()
                    let pay_res = res.data
                    window.location.href = pay_res.link_url
                }).catch(res => {
                    this.$dialog.loading.close()
                    return this.$dialog.error(res.data.msg)
                })
            }
        }
    }
</script>

<style scoped>
    /*.row-wrap{margin-top: 50px}*/
    .row-T1 {
        font-size: .3rem;
        color: #708090;
        padding: 70px 0 10px 5px;
    }

    .row {
        width: 100%;
        padding: 0 0.27rem;
        box-sizing: border-box;
        background: #fff;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        position: relative;
    }

    .row::after {
        content: "";
        position: absolute;
        width: calc(100% - 0.27rem - 0.27rem);
        bottom: 0px;
        left: 0;
        right: 0;
        margin: 0 auto;
        height: 1px;
        background: #eee;
    }

    .row .row-name {
        width: 2.5rem;
    }

    .row .input {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .row .select {
        flex: 1;
        display: block;
        height: 1rem;
        line-height: 1rem;
        box-sizing: border-box;
        padding-left: 0.15rem;
        border: none;
        background: #fff;
    }

    .pay-btn {
        display: block;
        width: 5.5rem;
        height: 0.86rem;
        margin: 0.5rem auto 0 auto;
        line-height: 0.86rem;
        text-align: center;
        color: #fff;
        border-radius: 0.15rem;
        font-size: 0.3rem;
        font-weight: bold;
    }
</style>